__turbopack_context__.v({
  "description": "Error-module-scss-module__pj2CYG__description",
  "icon": "Error-module-scss-module__pj2CYG__icon",
  "root": "Error-module-scss-module__pj2CYG__root",
  "title": "Error-module-scss-module__pj2CYG__title",
});
